import api from './client';

export enum ReportType {
  INCOME_STATEMENT = 'INCOME_STATEMENT',
  BALANCE_SHEET = 'BALANCE_SHEET',
  CASH_FLOW = 'CASH_FLOW',
  COST_CENTER = 'COST_CENTER',
  CUSTOM = 'CUSTOM',
}

export enum ReportPeriod {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  YEARLY = 'YEARLY',
  CUSTOM = 'CUSTOM',
}

export interface ReportLineItem {
  category: string;
  description: string;
  amount: number;
  subItems?: ReportLineItem[];
}

export interface FinancialReport {
  id: string;
  title: string;
  type: ReportType;
  period: ReportPeriod;
  startDate: string;
  endDate: string;
  costCenterId?: string;
  lineItems: ReportLineItem[];
  notes?: string;
  totalAmount: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateFinancialReportDto {
  title: string;
  type: ReportType;
  period: ReportPeriod;
  startDate: string;
  endDate: string;
  costCenterId?: string;
  lineItems: ReportLineItem[];
  notes?: string;
}

export type UpdateFinancialReportDto = Partial<CreateFinancialReportDto>;

export interface GetFinancialReportsFilters {
  type?: ReportType;
  costCenterId?: string;
}

export const financialReportsApi = {
  async getFinancialReports(
    filters: GetFinancialReportsFilters = {},
  ): Promise<FinancialReport[]> {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value.toString());
      }
    });
    const query = params.toString();
    const response = await api.get<FinancialReport[]>(
      `financial-reports${query ? `?${query}` : ''}`,
    );
    return response.data;
  },

  async getFinancialReport(id: string): Promise<FinancialReport> {
    const response = await api.get<FinancialReport>(`financial-reports/${id}`);
    return response.data;
  },

  async createFinancialReport(data: CreateFinancialReportDto): Promise<FinancialReport> {
    const response = await api.post<FinancialReport>('financial-reports', data);
    return response.data;
  },

  async updateFinancialReport(
    id: string,
    data: UpdateFinancialReportDto,
  ): Promise<FinancialReport> {
    const response = await api.put<FinancialReport>(`financial-reports/${id}`, data);
    return response.data;
  },

  async deleteFinancialReport(id: string): Promise<void> {
    await api.delete(`financial-reports/${id}`);
  },
};

export default financialReportsApi;
